import "./Method.css";

function Method() {
  return (
    <main id="top" className="content-inner">
      <section id="method" className="method-section">

        <div className="method-intro">
          <div>
            <h2>Built to be checked<span style={{ color: "#EF3A5D" }}>.</span></h2>
          </div>

          <p>
            Most indices ask you to trust them. This one comes with a working paper, its own error rate printed in it.
          </p>
        </div>

        <div className="method-grid">

          <div className="method-card">
            <div className="method-number">06</div>

            <h4>Six newspapers, one series.</h4>

            <p>
              Rzeczpospolita and Parkiet since 2000; Gazeta Wyborcza and Dziennik Gazeta Prawna from 2009, 
              Gazeta Polska Codziennie from 2011, Puls Biznesu from 2014. Left and right, business and general. 
              Each title is spliced in so a new paper never looks like a new crisis. The historical archives 
              are extracted in-house.
            </p>
          </div>

          <div className="method-card">
            <div className="method-number">9,123</div>

            <h4>A quarter-century, day by day.</h4>

            <p>
              9,123 daily observations of article counts form the basis of the monthly index: 318 months, 
              January 2000 to June 2026.
            </p>
          </div>

          <div className="method-card">
            <div className="method-number">600</div>

            <h4>Six hundred articles read by people.</h4>

            <p>
              Trained annotators coded 600 articles without seeing what the algorithm 
              had decided. On an overlap sample of 120 articles, each coded independently by two annotators,
              they agreed in 87.5% of cases (Fleiss’ κ = 0.74).
            </p>
          </div>

          <div className="method-card">
            <div className="method-number">70.2%</div>

            <h4>Seven in ten, and we say so.</h4>

            <p>
              Of the articles the index flags, about seven in ten are genuinely about 
              economic policy uncertainty. Most of the rest are uncertainty about 
              something else, or policy words used outside the economy. Precision 
              ranges from 66% to 80% across sub-periods, with no sign that it is 
              driven by crisis episodes. Every dictionary-based index makes errors like these. 
              We print ours.
            </p>
          </div>

          <div className="method-card">
            <div className="method-number">Free</div>

            <h4>Open to read and reuse.</h4>

            <p>
              The monthly series from January 2000 to June 2026 is on the data page and on OSF. 
              Released under CC BY 4.0. Reuse it with attribution to the working paper.
            </p>
          </div>

          <div className="method-card method-card-dark">
            <p>
              The newspapers, the dictionary, the audit and the tests are documented in the paper
              and its replication files.
            </p>

            <a href="research.html">
              Read the working paper →
            </a>
          </div>

        </div>
      </section>
    </main>
  );
}

export default Method;